<ion-item
  (click)="coupon.status === 'active' ? openKioskCoupounQrDisplayModal() : ''"
  [button]="coupon.status === 'active' ? true : false"
  lines="full"
  detail="false"
  *ngIf="coupon"
  [ngClass]="coupon.status + '_border'"
  [class.no-item-padding]="!fromDiscountCouponsPage"
>
  <ion-icon
    *ngIf="coupon.status === 'active'"
    style="font-size: 35px; margin: 0"
    slot="start"
    src="assets/flatIcons/magnifier-qr.svg"
  >
  </ion-icon>
  <div
    *ngIf="coupon.status !== 'active' && !fromDiscountCouponsPage"
    slot="start"
    style="width: 35px; margin: 0"
  ></div>
  <ion-row style="width: 100%">
    <ion-col size="12">
      <ion-label class="ion-no-padding" class="ion-text-wrap">
        <p *ngIf="coupon.description">
          <strong>{{
            coupon.description_langs &&
            (coupon.description_langs[selectedLanguage] ||
              coupon.description_langs[selectedLangugage])
              ? coupon.description_langs[selectedLanguage] ||
                coupon.description_langs[selectedLangugage]
              : coupon.description_langs && coupon.description_langs[mo_base]
              ? coupon.description_langs[mo_base]
              : coupon.description
          }}</strong>
        </p>

        <p
          *ngIf="
            coupon.use_type &&
            coupon.use_type === 'third_party' &&
            coupon.third_party_code
          "
        >
          {{ "discount-coupons.coupons-item.third_party_code" | translate }}:
          {{ coupon.third_party_code }}
        </p>
        <p
          style="font-size: x-small; font-weight: 700"
          *ngIf="
            coupon.label &&
            !hasMinOrderModes &&
            coupon.appliesToOrderGreaterThan > 0
          "
        >
          {{ "discount-coupons.coupons-item.minimum-order" | translate }}:
          {{ coupon.appliesToOrderGreaterThan }}‎€<ng-container
            *ngIf="minOrderItemNames"
          >
            {{
              "cart.cart-components.cart-active-coupons.minimum-order-only-from"
                | translate
            }}: {{ minOrderItemNames }}</ng-container
          >
        </p>
        <p
          style="font-size: x-small; font-weight: 700"
          *ngIf="coupon.label && hasMinOrderModes && minOrderModes.length"
        >
          {{ "discount-coupons.coupons-item.minimum-order" | translate }}:
          <ng-container
            *ngFor="let minOrderMode of minOrderModes; let last = last"
          >
            {{ minOrderMode.modeKey | translate }}
            {{ minOrderMode.amount }}‎€<ng-container *ngIf="!last"
              >,
            </ng-container>
          </ng-container>
          <ng-container *ngIf="minOrderItemNames">
            {{
              "cart.cart-components.cart-active-coupons.minimum-order-only-from"
                | translate
            }}: {{ minOrderItemNames }}</ng-container
          >
        </p>
        <p
          style="font-size: x-small; font-weight: 700; line-height: 1.4"
          *ngIf="
            (coupon.discountType === 'percent' ||
              coupon.discountType === 'combined') &&
            coupon.maxDiscountAmount &&
            coupon.maxDiscountAmount !== '0'
          "
        >
          <ion-text>
            {{
              "cart.cart-components.cart-active-coupons.maximum-discount-amount"
                | translate
            }}&nbsp;{{ coupon.maxDiscountAmount }}€
          </ion-text>
        </p>
        <p
          style="font-size: x-small; font-weight: 700"
          *ngIf="coupon.activeFrom || coupon.activeTo"
        >
          {{ "discount-coupons.coupons-item.valid" | translate }}&nbsp;
          {{
            coupon.activeFrom
              ? ("discount-coupons.coupons-item.from" | translate) +
                " " +
                (coupon.activeFrom | date : "dd/MM/yyyy HH:mm") +
                " "
              : ""
          }}
          {{
            coupon.activeTo
              ? ("discount-coupons.coupons-item.to" | translate) +
                " " +
                (activeToDisplay | date : "dd/MM/yyyy")
              : ""
          }}
        </p>
        <p *ngIf="coupon.single_store_use">
          {{
            "discount-coupons.coupons-item.coupon-single-store-use" | translate
          }}
        </p>

        <p *ngIf="coupon.preorder_only">
          <ion-text color="danger">
            {{
              "discount-coupons.coupons-item.coupon-can-be-used-only-for-preorder"
                | translate
            }}
          </ion-text>
        </p>

        <p
          *ngIf="coupon.only_mobile_apps && !nativePlatform"
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
        >
          <ion-text color="danger">
            {{
              "cart.cart-components.cart-active-coupons.coupon-can-be-used-only-from-mobile-apps"
                | translate
            }}
          </ion-text>
        </p>

        <p *ngIf="coupon.status === 'pending_confirmation'">
          <ion-text color="danger">
            {{
              "discount-coupons.coupons-item.coupon-must-be-confirmed-from-store"
                | translate
            }}
          </ion-text>
        </p>

        <p *ngIf="showAppsMessage">
          <ion-text color="danger">
            {{
              "discount-coupons.coupons-item.find-it-in-cart-for-apps"
                | translate
            }}
          </ion-text>
        </p>

        <p
          *ngIf="
            stores &&
            stores.length > 1 &&
            storesByStoreId &&
            storesByStoreId[coupon.store_id] &&
            selectedLangugage
          "
        >
          {{ "discount-coupons.coupons-item.valid-to-store" | translate
          }}<strong>
            {{
              storesByStoreId[coupon.store_id].store_name_mobileorder &&
              storesByStoreId[coupon.store_id].store_name_mobileorder[
                selectedLangugage
              ]
                ? storesByStoreId[coupon.store_id].store_name_mobileorder[
                    selectedLangugage
                  ]
                : storesByStoreId[coupon.store_id].store_name_langs &&
                  storesByStoreId[coupon.store_id].store_name_langs[
                    selectedLangugage
                  ]
                ? storesByStoreId[coupon.store_id].store_name_langs[
                    selectedLangugage
                  ]
                : storesByStoreId[coupon.store_id].store_name_langs &&
                  storesByStoreId[coupon.store_id].store_name_langs.el
                ? storesByStoreId[coupon.store_id].store_name_langs.el
                : storesByStoreId[coupon.store_id].store_name
                ? storesByStoreId[coupon.store_id].store_name
                : ""
            }}
          </strong>
        </p>
      </ion-label>
    </ion-col>

    <ion-col size="12" class="ion-text-left" style="padding-top: 0px">
      <ion-badge
        *ngIf="
          showOriginBadges && showKioskBadge && coupon && coupon.kiosk === true
        "
        color="primary"
        style="margin-right: 6px"
        >KIOSK</ion-badge
      >
      <ion-badge
        *ngIf="showOriginBadges && coupon && !coupon.only_kiosk"
        color="primary"
        style="margin-right: 6px"
        >APPS</ion-badge
      >
      <ion-badge *ngIf="coupon.status" [color]="badgeColor">
        {{ "discount-coupons.coupons-item." + coupon.status | translate }}
        <ion-text *ngIf="coupon.order_id && coupon.status === 'used'"
          >#{{ coupon.order_id }}</ion-text
        >
      </ion-badge>
    </ion-col>
    <div
      style="position: absolute; bottom: 5px; right: 10px; font-size: x-small"
      *ngIf="coupon && coupon.points"
    >
      {{ "discount-coupons.coupons-item.from_lowercase" | translate }}
      {{ coupon.points }}
      {{ "discount-coupons.coupons-item.points" | translate }}
    </div>
  </ion-row>

  <ion-badge style="min-width: 32px; margin-left: 10px" slot="end">
    <span
      *ngIf="
        coupon.discountType !== 'percent' &&
        coupon.discountType !== 'combined' &&
        coupon.discount
      "
    >
      -{{ coupon.discount }}€
    </span>
    <span *ngIf="coupon.discountType === 'percent' && coupon.discount">
      -{{ coupon.discount }}%
    </span>
    <span
      *ngIf="
        coupon.discountType === 'combined' &&
        coupon.discount_percent &&
        coupon.discount_fixed
      "
    >
      -{{ coupon.discount_percent }}% & -{{ coupon.discount_fixed }}€
    </span>

    <span
      *ngIf="
        !(
          (coupon.discountType !== 'percent' &&
            coupon.discountType !== 'combined' &&
            coupon.discount) ||
          (coupon.discountType === 'combined' &&
            coupon.discount_percent &&
            coupon.discount_fixed)
        ) &&
        coupon.product_id &&
        coupon.classic_offer_product &&
        coupon.tag_comment
      "
    >
      {{ coupon.tag_comment }}
    </span>
    <span
      *ngIf="
        !(
          (coupon.discountType !== 'percent' &&
            coupon.discountType !== 'combined' &&
            coupon.discount) ||
          (coupon.discountType === 'combined' &&
            coupon.discount_percent &&
            coupon.discount_fixed)
        ) &&
        coupon.product_id &&
        !coupon.classic_offer_product
      "
    >
      {{ "free" | translate }}
    </span>
  </ion-badge>
</ion-item>
